<script>
	import Fetch from "./Fetch.svelte";
</script>

<style>
	.wrapper {
		max-width: 350px;
		margin: 0 auto;
	}

	ul, li {
		list-style: none;
		padding: 0px;
		margin: 0px;
	}

	.days {
		margin-top: 100px;
	}

	.days > li {
		border-top: 1px solid #eee;
		margin: 15px 0px 0px 0px;
	}

	.days li:first-child {
		border: 0px;
	}

	.reviews {
		width: 100%;
	}

	.reviews li {
		padding: 2px 0px;
		display: block;
		overflow: hidden;
		font-size: 13px;
		line-height: 1.6;
	}

	.reviews li > * {
		margin-right: 3px;
	}

	.rating-block {
		display: inline;
		background-color: rgba(255,0,0,.1);
		padding: 1px 2px;
	}

	.time {
		color: #BBB;
		font-size: 11px;
	}

	.title {
		color: #007cff;
	}

	.good {
		background-color: rgba(0,255,0,.1);
	}

	h4 {
		font-size: 12px;
		font-weight: bold;
	}

	h4::nth-child(1) {
		border-top: 0px;
	}

	.rating {
		margin-left: 3px;
	}

	.review-text {
		text-transform: uppercase;
		font-family: 'Helvetica Neue', sans-serif;
		color: #666;
		letter-spacing: -.4px;
		word-spacing: .4px;
	}

	@media only screen and (max-width: 600px) {
		body {
			background-color: black;
		}
	  .wrapper {
	    width: 100%;
			max-width: none;
			padding: 0px 20px;
			box-sizing: border-box;
	  }
		.reviews li {
			padding: 2px 0px;
		}
		.time, h4 {
			font-size: 13px;
		}
	}

</style>

<!-- <h1>All Reviews</h1> -->

<Fetch let:feed>
	<div class="wrapper">
		<ul class="days">
			<!-- <pre><code>{JSON.stringify(data, null, " ")}</code></pre> -->
			{#each feed as day}
				<li>
					<h4>{day.smdate}</h4>
					<ul class="reviews">
						{#each day.reviews as review}
							<li>
								<span class="time">{review.time}</span>
								<span class="title">{review.title}</span>
								<span class="rating-block"
									class:good={(review.rating >= 0)}>
									<span class="epkey">{review.epkey}</span>
									<span class="rating">
										{(review.rating >= 1) ? '+' + review.rating : review.rating}
									</span>
								</span>
								{#if review.review }
									<div class="review-text">{review.review}</div>
								{/if}
							</li>
						{/each}
					</ul>
				</li>
			{:else}
				<!-- this block renders when reviews.length === 0 -->
				<p>loading...</p>
			{/each}
		</ul>
	</div>
</Fetch>
